/**
 * The Growth Strategist account tab strip: the six tabs of the GS design
 * (egs-view at e7603325b), in its order, with its labels, then Delphi (2026-10-22).
 * Opps, Workspaces and Intelligence are not offered to a Growth Strategist (decisions of
 * 2026-10-08), and neither is Fields, since the GS page has no fields column.
 */
export const GS_ACCOUNT_STRIP = [
  { value: 'summary', label: 'Summary' },
  { value: 'product-usage', label: 'Product Usage' },
  { value: 'people', label: 'People' },
  { value: 'open-loops', label: 'Open Loops' },
  { value: 'timeline', label: 'Timeline' },
  { value: 'signals', label: 'Signals' },
  { value: 'delphi', label: 'Delphi' },
] as const;

export type GsAccountTab = (typeof GS_ACCOUNT_STRIP)[number]['value'];

/** The strip's values, for the layout that resolves `?accountTab=` against them. */
export const GS_ACCOUNT_TABS: readonly GsAccountTab[] = GS_ACCOUNT_STRIP.map(entry => entry.value);
